import { Injectable, inject } from '@angular/core';
import { ItemTemplateRepository } from '../repositories/item-template.repository';
import { OrderItem } from '../models/order-item';
import { OrderTypeEnum } from '../models/order-type-enum';

@Injectable()
export class ItemTemplateService {
  #itemTemplateRepository = inject(ItemTemplateRepository);

  async getItemTemplate(
    request: Partial<OrderItem>,
    orderType: OrderTypeEnum = OrderTypeEnum.GARAGE
  ): Promise<OrderItem> {
    return await this.#itemTemplateRepository.retrieve(request, orderType);
  }
}
